import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";

import { checkAndFormatPhoneNumber } from "../../lib/utils";
import ArrUpIcon from "../ui/ArrUpIcon";
import BookingFormHeader from "./BookingFormHeader";
import BookingFormSteps from "./BookingFormSteps";
import BookingFormCardPrices from "./BookingFormCardPrices";
import BookingFormCardTwo from "./BookingFormCardTwo";
import { siteUrl } from "../../config";
import searchStore from "../../store/searchStore";

function BookingFormContacts({
  booking,
  hoteldata,
  prevStep,
  datein,
  dateout,
  bookingHandler,
  onClose,
}) {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    guestname: [],
    guestsurname: [],
  });
  const [phoneNumber, setPhoneNumber] = useState(
    checkAndFormatPhoneNumber("")[0],
  );
  const [acceptRules, setAcceptRules] = useState(false);
  const [isForAnother, setIsForAnother] = useState(false);
  const [scrolled, setScrolled] = useState(0);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   setFormData({
  //     name: app?.userData?.name || "",
  //     surname: app?.userData?.lastname || "",
  //     email: app?.userData?.email || "",
  //     guestname: [app?.userData?.name || ""],
  //     guestsurname: [app?.userData?.lastname || ""],
  //   });
  //   setPhoneNumber(checkAndFormatPhoneNumber(app?.userData?.phone.slice(1))[0]);
  //   setLoading(false);
  // }, [app.userData.email]);

  const toggleIsForAnother = (values, setFieldValue) => {
    if (!!isForAnother) {
      // галочка снята
      // возвращаем значения по умолчанию для первого гостя (= заказчику)
      setFieldValue("guestname[0]", values["name"]);
      setFieldValue("guestsurname[0]", values["surname"]);
    }
    setIsForAnother(!isForAnother);
  };

  const changePhoneHandler = (e) => {
    setPhoneNumber(checkAndFormatPhoneNumber(e.target.value)[0]);
  };

  const handleScroll = (event) => {
    const { scrollTop } = event.target;
    setScrolled((prev) => prev + 1);
  };

  // if (loading) {
  //   return <p>Обновляю форму.. 1</p>;
  // }

  return (
    <Formik
      initialValues={formData}
      onSubmit={async (values) =>
        bookingHandler({
          ...values,
          phone: phoneNumber.replace(/\D/g, ""),
          for_another: isForAnother,
        })
      }
      // enableReinitialize={true}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <div className="bookingWrap formTwo" onScroll={handleScroll}>
            <BookingFormHeader
              title={
                <span className="customerHeaderInputs">
                  <Field
                    name="name"
                    type="text"
                    placeholder="Имя"
                    required
                    className="mr6"
                  />
                  <Field
                    name="surname"
                    type="text"
                    placeholder="Фамилия"
                    required
                  />
                </span>
              }
              datein={datein}
              dateout={dateout}
              onClose={onClose}
            />
            <div className="bookingForm">
              <div className="bookingCard bookingCard__customer">
                <div className="bookingInfo mb12 mt0 mob_show">
                  <div className="small gray">
                    <input
                      type="checkbox"
                      name="rules"
                      checked={acceptRules}
                      onChange={() => setAcceptRules((prev) => !prev)}
                    />{" "}
                    Соглашаюсь с обработкой персональных данных и{" "}
                    <a
                      target="_blank"
                      href={`${siteUrl}/pages/privacy`}
                      rel="noopener noreferrer"
                    >
                      политикой конфиденциальности
                    </a>
                    .
                  </div>
                  {hoteldata?.reservation_request && (
                    <div className="info">
                      Наличие номеров на запрошенные вами даты не гарантируется,
                      обязательно дождитесь подтверждения вашей заявки
                      владельцем отеля
                    </div>
                  )}
                </div>
                <div className="mob_show">
                  <div className="bookingForm formField customerNameMobile">
                    <span className="guestTitle">Заказчик</span>
                    <Field
                      name="name"
                      type="text"
                      placeholder="Имя"
                      required
                      className="customerHeader"
                    />
                  </div>
                  <div className="bookingForm formField">
                    <Field
                      name="surname"
                      type="text"
                      placeholder="Фамилия"
                      className="customerHeader"
                      required
                    />
                  </div>
                </div>
                <div className="formField">
                  <Field
                    name="phone"
                    type="text"
                    placeholder="+7"
                    value={phoneNumber}
                    onChange={changePhoneHandler}
                    required
                    className={phoneNumber.length === 4 && "placeholder"}
                  />
                </div>
                <div className="formField">
                  <Field
                    name="email"
                    type="email"
                    placeholder="Email"
                    required
                  />
                </div>
                <div className="bookingCard bookingCard__customer cww mt6">
                  <div className="formField">
                    <Field
                      name="customer_wish"
                      component="textarea"
                      rows={4}
                      placeholder="Ваш комментарий"
                      className="customerWish"
                    />
                  </div>
                </div>
                {hoteldata?.guests_info_required && (
                  <div className="formField for_another mt12 pl12">
                    <div className="dfa small">
                      <Field
                        name="for_another"
                        type="checkbox"
                        id="for_another"
                        className="customRadioCheck"
                        checked={isForAnother}
                        onChange={() =>
                          toggleIsForAnother(values, setFieldValue)
                        }
                      />{" "}
                      <label htmlFor="for_another">
                        Бронирую для другого человека
                      </label>
                    </div>
                  </div>
                )}
                <div className="bookingForm bookingGuests">
                  {Array.from(
                    {
                      length:
                        searchStore.guestsCount +
                          searchStore.guestsChildren?.length || 0,
                    },
                    (_, index) => (
                      <div className="guestItem" key={`guest_${index}`}>
                        <div className="bookingCard formField">
                          <b className="guestTitle">Гость&nbsp;{index + 1}</b>
                          <Field
                            name={
                              !isForAnother && index === 0
                                ? `name`
                                : `guestname[${index}]`
                            }
                            type="text"
                            placeholder="Имя"
                            disabled={!isForAnother && index === 0}
                            required={!!hoteldata?.guests_info_required}
                          />
                          {!!hoteldata?.guest_data_extended && (
                            <>
                              <b className="guestTitle">Дата рождения:</b>
                              <Field
                                name={`birthday[${index}]`}
                                type="date"
                                className="w100p"
                                placeholder="Дата рождения"
                                required={true}
                              />
                            </>
                          )}
                        </div>
                        <div className="bookingCard formField">
                          <Field
                            name={
                              !isForAnother && index === 0
                                ? `surname`
                                : `guestsurname[${index}]`
                            }
                            type="text"
                            placeholder="Фамилия"
                            disabled={!isForAnother && index === 0}
                            required={!!hoteldata?.guests_info_required}
                          />
                          {!!hoteldata?.guest_data_extended && (
                            <>
                              <b className="guestTitle">Документ:</b>
                              <Field
                                name={`document[${index}]`}
                                type="text"
                                placeholder="Документ"
                                required={true}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
              <BookingFormCardPrices
                hoteldata={hoteldata}
                booking={booking}
                booking_step={true}
                acceptRules={acceptRules}
                setAcceptRules={setAcceptRules}
              />
              <BookingFormCardTwo
                booking={booking}
                hoteldata={hoteldata}
                step="contacts"
                scrolled={scrolled}
                prevStep={prevStep}
                nextStep={() => null}
                acceptRules={acceptRules}
                datein={datein}
                dateout={dateout}
                onClose={onClose}
              />
            </div>
            <div className="bookingCard__navBtns dfsp dfa mob_hide">
              <span className="changeTariff" onClick={prevStep}>
                <ArrUpIcon fill="#36549C" />
                назад
              </span>
              <button
                className="bookingCard__nextBtn"
                type="submit"
                disabled={!acceptRules}
              >
                Забронировать
              </button>
            </div>
            <BookingFormSteps step="contacts" count={hoteldata.steps_count} />
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default observer(BookingFormContacts);
